import React from "react"
import { Box, Flex, Grid, Heading } from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"

const TextBlock = ({ title, body, alignLeftOrTop }) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Grid
        columns={["1fr", ".3fr .7fr"]}
        sx={{
          mt: [0],
          pt: [5],
          pb: [5],
          borderTop: "2px solid",
          borderColor: "primary",
        }}
      >
        {!alignLeftOrTop ? (
          <Flex
            sx={{
              flexDirection: "column",
              pl: [0],
              pr: [6],
              pb: [0, 0],
            }}
          >
            <Box>
              <Heading as="h2" variant="h3" color="dark" sx={{ mt: 0 }}>
                {title}
              </Heading>
            </Box>
          </Flex>
        ) : (
          <Box></Box>
        )}
        <Box
          sx={{
            position: ["relative", "relative", "relative"],
            width: ["100%", "100%", "100%"],
            height: "100%",
          }}
        >
          {alignLeftOrTop && (
            <Flex
              sx={{
                flexDirection: "column",
                backgroundColor: "dark",
                px: [6, 6, 6, 8],
                py: [7],
              }}
            >
              <Box>
                <Heading color="primary">{title}</Heading>
              </Box>
            </Flex>
          )}
          <Box
            sx={{
              a: {
                color: "primary",
                textDecoration: "underline",
              },
            }}
          >
            <RichContentStructuredText text={body} />
          </Box>
        </Box>
      </Grid>
    </Box>
  )
}

export default TextBlock
